<template>
  <div>
    <div class="row mb-2" v-if="certTypeOptions.length">
      <div class="col-md-3">
        <label>{{ $t("bulletin.manageCertType") }} </label>
      </div>

      <div class="col-md-9">
        <a-select
          :value="selectedCertType"
          @change="handleCertTypeChange"
          style="width: 100%"
        >
          <a-select-option
            v-for="opt in certTypeOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <a-divider orientation="left" v-if="certTypeOptions.length"> </a-divider>
    <a-button icon="book" @click="showModal" :disabled="isReadOnly" style="margin-bottom: 20px">
      {{ $t("certification.add") }}
    </a-button>
    <a-popconfirm
      :title="$t('certification.confirmDefault')"
      @confirm="() => setDefaultCertifications()"
    >
      <a-button :disabled="isReadOnly" style="position: absolute; right: 40px">
        {{ $t("certification.default") }}
      </a-button>
    </a-popconfirm>

    <a-modal
      v-model="visibleModal"
      @cancel="handleCancel"
      width="50%"
      :title="$t('all.enterInformationBelow')"
      :footer="false"
      :maskClosable="false"
    >
      <a-form :form="form" @submit="addCertification">
        <a-form-item :label="$t('certification.name')">
          <a-input
            :placeholder="$t('certification.namePlaceholder')"
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: $t('requis.nom'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <div class="row">
          <div class="col">
            <a-form-item :label="$t('certification.min')">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 80%"
                :placeholder="$t('certification.min')"
                v-decorator="[
                  'min',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('requis.min'),
                      },
                      {
                        validator: (rule, value, callback) => {
                          if (
                            Number(this.form.getFieldValue('max')) <
                            Number(value)
                          ) {
                            callback($t('certification.minError'));
                          } else {
                            callback();
                          }
                        },
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col">
            <a-form-item :label="$t('certification.max')">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 80%"
                :placeholder="$t('certification.max')"
                v-decorator="[
                  'max',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('requis.max'),
                      },
                      {
                        validator: (rule, value, callback) => {
                          if (
                            Number(this.form.getFieldValue('min')) >
                            Number(value)
                          ) {
                            callback($t('certification.maxError'));
                          } else {
                            callback();
                          }
                        },
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>

        <div class="row" v-if="verifyPackAccess('certificate')">
          <a-divider>{{ $t("certification.addCertificateDesigns") }}</a-divider>
          <div class="col-md-6">
            <a-form-item
              :label="$t('choisir.template') + ' ' + $t('profil.garcon')"
            >
              <a-upload-dragger
                v-decorator="[
                  'photo',
                  {
                    rules: [
                      {
                        required: false,
                      },
                    ],
                  },
                ]"
                :multiple="false"
                :file-list="fileListM"
                :before-upload="(file) => beforeUpload(file, 'm')"
                :customRequest="(options) => addTofileList('m', options)"
                :remove="(file) => handleRemoveFile(file, 'm')"
                name="file"
              >
                <div>
                  <p class="ant-upload-drag-icon">
                    <a-icon :type="'file'" />
                  </p>
                  <div class="ant-upload-text" style="font-size: 12px">
                    {{ $t("etablissement.clickOrDragToUpload") }}
                  </div>
                </div>
              </a-upload-dragger>
              <span class="subLabel">
                {{ $t("pack.typeNeededPNG") }}
              </span>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item
              :label="$t('choisir.template') + ' ' + $t('profil.fille')"
            >
              <a-upload-dragger
                v-decorator="[
                  'photo',
                  {
                    rules: [
                      {
                        required: false,
                      },
                    ],
                  },
                ]"
                :multiple="false"
                :file-list="fileListF"
                :before-upload="(file) => beforeUpload(file, 'f')"
                :customRequest="(options) => addTofileList('f', options)"
                :remove="(file) => handleRemoveFile(file, 'f')"
                name="file"
              >
                <div>
                  <p class="ant-upload-drag-icon">
                    <a-icon :type="'file'" />
                  </p>
                  <div class="ant-upload-text" style="font-size: 12px">
                    {{ $t("etablissement.clickOrDragToUpload") }}
                  </div>
                </div>
              </a-upload-dragger>
              <span class="subLabel">
                {{ $t("pack.typeNeededPNG") }}
              </span>
            </a-form-item>
          </div>

          <a-progress
            :stroke-color="{
              from: '#108ee9',
              to: '#87d068',
            }"
            v-if="uploadPercentage.value > 0"
            :percent="uploadPercentage.value"
            status="active"
            class="mb-2"
          />
        </div>

        <div class="form-actions mt-0">
          <a-button
            type="primary"
            htmlType="submit"
            :loading="loadingClasse"
            :disabled="loadingClasse"
            class="mr-3"
          >
            {{ $t("action.ajouter") }}
          </a-button>
          <a-button
            key="back"
            @click="handleCancel"
            :disabled="loadingClasse"
            >{{ $t("action.annuler") }}</a-button
          >
        </div>
      </a-form>
    </a-modal>

    <a-modal
      v-model="visibleEditModal"
      @cancel="handleCancel"
      width="50%"
      :title="$t('all.enterInformationBelow')"
      :footer="false"
    >
      <a-form :form="formEdit" @submit="handelEdit">
        <a-form-item :label="$t('certification.name')">
          <a-input
            :placeholder="$t('certification.namePlaceholder')"
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: $t('requis.nom'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <div class="row">
          <div class="col">
            <a-form-item :label="$t('certification.min')">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 80%"
                :placeholder="$t('certification.min')"
                v-decorator="[
                  'min',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('requis.min'),
                      },
                      {
                        validator: (rule, value, callback) => {
                          if (
                            Number(this.form.getFieldValue('max')) <
                            Number(value)
                          ) {
                            callback($t('certification.minError'));
                          } else {
                            callback();
                          }
                        },
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col">
            <a-form-item :label="$t('certification.max')">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 80%"
                :placeholder="$t('certification.max')"
                v-decorator="[
                  'max',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('requis.max'),
                      },
                      {
                        validator: (rule, value, callback) => {
                          if (
                            Number(this.form.getFieldValue('min')) >
                            Number(value)
                          ) {
                            callback($t('certification.maxError'));
                          } else {
                            callback();
                          }
                        },
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>

          <div class="hidden">
            <a-form-item>
              <a-input v-decorator="['id']" />
            </a-form-item>
          </div>
        </div>

        <div class="row" v-if="verifyPackAccess('certificate')">
          <a-divider>{{ $t("certification.addCertificateDesigns") }}</a-divider>
          <div class="col-md-6">
            <a-form-item
              :label="$t('choisir.template') + ' ' + $t('profil.garcon')"
            >
              <a-upload-dragger
                v-decorator="[
                  'photo',
                  {
                    rules: [
                      {
                        required: false,
                      },
                    ],
                  },
                ]"
                :multiple="false"
                :file-list="fileListM"
                :before-upload="(file) => beforeUpload(file, 'm')"
                :customRequest="(options) => addTofileList('m', options)"
                :remove="(file) => handleRemoveFile(file, 'm')"
                name="file"
              >
                <div>
                  <p class="ant-upload-drag-icon">
                    <a-icon :type="'file'" />
                  </p>
                  <div class="ant-upload-text" style="font-size: 12px">
                    {{ $t("etablissement.clickOrDragToUpload") }}
                  </div>
                </div>
              </a-upload-dragger>
              <span class="subLabel">
                {{ $t("pack.typeNeededPNG") }}
              </span>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item
              :label="$t('choisir.template') + ' ' + $t('profil.fille')"
            >
              <a-upload-dragger
                v-decorator="[
                  'photo',
                  {
                    rules: [
                      {
                        required: false,
                      },
                    ],
                  },
                ]"
                :multiple="false"
                :file-list="fileListF"
                :before-upload="(file) => beforeUpload(file, 'f')"
                :customRequest="(options) => addTofileList('f', options)"
                :remove="(file) => handleRemoveFile(file, 'f')"
                name="file"
              >
                <div>
                  <p class="ant-upload-drag-icon">
                    <a-icon :type="'file'" />
                  </p>
                  <div class="ant-upload-text" style="font-size: 12px">
                    {{ $t("etablissement.clickOrDragToUpload") }}
                  </div>
                </div>
              </a-upload-dragger>
              <span class="subLabel">
                {{ $t("pack.typeNeededPNG") }}
              </span>
            </a-form-item>
          </div>

          <a-progress
            :stroke-color="{
              from: '#108ee9',
              to: '#87d068',
            }"
            v-if="uploadPercentage.value > 0"
            :percent="uploadPercentage.value"
            status="active"
            class="mb-2"
          />
        </div>

        <div class="form-actions mt-0">
          <a-button
            type="primary"
            htmlType="submit"
            :loading="loadingClasse"
            :disabled="loadingClasse"
            class="mr-3"
          >
            {{ $t("action.modifier") }}
          </a-button>
          <a-button
            key="back"
            @click="handleCancel"
            :disabled="loadingClasse"
            >{{ $t("action.annuler") }}</a-button
          >
        </div>
      </a-form>
    </a-modal>
    <configPrintModal
      :certif="selectedCertif"
      :selectedCertType="selectedCertType"
      :visible="visibleConfigPrintModal"
      :key="keyIndex"
      @close="handleClose"
      @save="getCetification"
    />
    <div class="card">
      <a-table
        :loading="tableLeading"
        :rowKey="'_id'"
        :columns="columns"
        :data-source="data"
        :pagination="false"
      >
        <template slot="name" slot-scope="text, record">
          <div key="name">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="(e) => handleChange(e.target.value, record.id, 'name')"
            />
            <template v-else>
              <a-tag>{{ text }}</a-tag>
            </template>
          </div>
        </template>
        <template slot="min" slot-scope="text, record">
          <div key="min">
            <a-input-number
              :min="0"
              :max="20"
              v-if="record.editable"
              style="margin: -5px 0"
              :default-value="text"
              @change="(value) => handleChange(value, record.id, 'min')"
            />
            <template v-else>
              <a-tag color="red">{{ text }}</a-tag></template
            >
          </div>
        </template>
        <template slot="max" slot-scope="text, record">
          <div key="max">
            <a-input-number
              :min="0"
              :max="20"
              v-if="record.editable"
              style="margin: -5px 0"
              :default-value="text"
              @change="(value) => handleChange(value, record.id, 'max')"
            />
            <template v-else>
              <a-tag color="green">{{ text }}</a-tag>
            </template>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <span>
              <a-button type="primary" @click="() => edit(record)" :disabled="isReadOnly">
                <a-icon type="edit" />{{ $t("action.modifier") }}
              </a-button>
            </span>
          </div>
        </span>
        <span slot="operationConfig" slot-scope="text, record">
          <div>
            <span>
              <a-button
                type="primary"
                @click="() => printConfig(record)"
                :disabled="!record.fileF && !record.fileM"
              >
                <a-icon type="edit" />{{ $t("bulletin.configureDisplay") }}
              </a-button>
            </span>
          </div>
        </span>
        <span slot="operationSupprimer" slot-scope="text, record">
          <div class="editable-row-operations">
            <span>
              <a-button :disabled="editingKey !== '' || isReadOnly" type="danger">
                <a-popconfirm
                  :title="$t('requis.supp')"
                  @confirm="() => supp(record.id)"
                >
                  <a>{{ $t("action.supprimer") }}</a>
                </a-popconfirm>
              </a-button>
            </span>
          </div>
        </span>
      </a-table>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import { mapState, mapGetters } from "vuex";
import configPrintModal from "./components/configPrintModal";
import { uploadFilesToS3 } from "@/services/uploadService";
import {
  isPrimarySchoolType,
  isCollegeSchoolType,
} from "@/config/Constants";

export default {
  name: "certifications-configuration",
  components: {
    configPrintModal,
  },
  beforeMount() {
    this.form = this.$form.createForm(this, { name: "CertificationForm" });
    this.formEdit = this.$form.createForm(this, {
      name: "editCertificationForm",
    });
  },
  async created() {
    const opts = this.certTypeOptions;
    if (opts.length && !opts.find((o) => o.value === this.selectedCertType)) {
      this.selectedCertType = opts[0].value;
    }
   this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - Certificat",
    });
    await this.getCetification();
  },
  data() {
    return {
      selectedCertType: "MP",
      tableLeading: true,
      visibleModal: false,
      visibleEditModal: false,
      form: this.$form.createForm(this),
      data: null,
      cacheData: null,
      loadingClasse: false,
      editingKey: "",
      defaultData: [
        // { id: 1, key: 1, min: 18, max: 20, name: "شهادة امتياز" },
        { id: 2, key: 2, min: 16, max: 17.99, name: "شهادة شكر" },
        { id: 3, key: 3, min: 15, max: 15.99, name: "شهادة شرف" },
        { id: 4, key: 4, min: 14, max: 14.99, name: "شهادة تشجيع" },
        //   { id: 5, key: 5, min: 13, max: 13.99, name: "شهادة رضا" },
      ],
      selectedCertif: {},
      visibleConfigPrintModal: false,
      keyIndex: 0,
      fileListM: [],
      fileListF: [],
      uploadPercentage: { value: 0 },
      certifImageMale: null,
      certifImageFemale: null,
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["packDetailsGetter"]),
    isPrimarySchool() {
      return isPrimarySchoolType(this.schoolDetails?.type);
    },
    isCollegeSchool() {
      return isCollegeSchoolType(this.schoolDetails?.type);
    },
    // Options by school type: primary → MP, MS; college/lycee → college
    certTypeOptions() {
      const options = [];
      if (this.isPrimarySchool) {
        options.push({
          value: "MP",
          label: this.$t("bulletin.bulletinPedagogique"),
        });
        options.push({
          value: "MS",
          label: this.$t("bulletin.bulletinVerySpecifique"),
        });
      }
      if (this.isCollegeSchool) {
        options.push({
          value: "college",
          label: this.$t("menu.bulletinCollege"),
        });
      }
      return options;
    },
    isReadOnly() {
      const value = this.packDetailsGetter?.access?.edManager?.certificats;
      return value === "ro";
    },
    schoolDetails() {
      return (
        this.user.building.filter(
          (el) => el.dbName == this.settings.activeBuilding
        )[0] || {}
      );
    },
    baseColumns() {
      return [
        {
          title: this.$t("certification.name"),
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("certification.min"),
          dataIndex: "min",
          key: "min",
          scopedSlots: { customRender: "min" },
          sorter: (a, b) => a.min - b.min,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("certification.max"),
          dataIndex: "max",
          key: "max",
          scopedSlots: { customRender: "max" },
          sorter: (a, b) => a.max - b.max,
          sortDirections: ["descend", "ascend"],
        },

        {
          title: this.$t("action.modifier"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          fixed: "right",
        },
        {
          title: this.$t("bulletin.configureDisplay"),
          dataIndex: "operationConfig",
          scopedSlots: { customRender: "operationConfig" },
          fixed: "right",
        },
        {
          title: this.$t("action.supprimer"),
          dataIndex: "operationSupprimer",
          scopedSlots: { customRender: "operationSupprimer" },
          fixed: "right",
        },
      ];
    },
    columns() {
      return this.baseColumns.filter((column) => {
        // Hide the "Configurer l'affichage" column if verifyPackAccess('certificate') returns false
        if (column.dataIndex === "operationConfig") {
          return this.verifyPackAccess("certificate");
        }
        return true;
      });
    },
  },
  methods: {
    handleApiError(error, defaultMessage) {
      // Check for PACK_PERMISSION_ERROR
      if (
        error.response?.data?.errorCode === "PACK_PERMISSION_ERROR" ||
        error.response?.data?.error?.errorCode === "PACK_PERMISSION_ERROR"
      ) {
        this.$message.error(this.$t("errorCode.PACK_PERMISSION_ERROR"));
        return;
      }
      // Fallback to default error message
      this.$message.error(
        error.response?.data?.message || defaultMessage || this.$t("error.erreur")
      );
    },
    verifyPackAccess: function (item) {
      return this.schoolDetails.pack.access.edManager[item] == "v";
    },
    async handleCertTypeChange(val) {
      this.selectedCertType = val;
      await this.getCetification();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async getCetification() {
      this.tableLeading = true;
      await apiClient
        .get("/certification/" + this.selectedCertType)
        .then((res) => {
          let certificationsData = [...res.data];
          if (certificationsData.length == 0)
            this.$message.warning(this.$t("error.aucCert"));
          certificationsData = certificationsData.map((elem) => {
            return {
              ...elem,
              key: elem.id,
            };
          });
          this.data = certificationsData;
          this.cacheData = certificationsData.map((item) => ({ ...item }));
          this.tableLeading = false;
        })
        .catch((e) => {
          this.$message.error(this.$t("error.erreur"));
          this.tableLeading = false;
        });
    },
    addCertification(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.loadingClasse = true;
          try {
            const certificationData = {
              name: values.name,
              min: values.min,
              max: values.max,
            };
            const filesToUpload = [];
            if (this.certifImageMale) filesToUpload.push(this.certifImageMale);
            if (this.certifImageFemale)
              filesToUpload.push(this.certifImageFemale);

            if (filesToUpload.length > 0) {
              const uploadedFiles = await uploadFilesToS3(
                filesToUpload,
                "manager/certification",
                this.uploadPercentage
              );

              // Assign uploaded files to certification data (same order as filesToUpload: male then female)
              if (uploadedFiles.length > 0) {
                let idx = 0;
                if (this.certifImageMale) {
                  certificationData.fileM = uploadedFiles[idx];
                  idx++;
                }
                if (this.certifImageFemale) {
                  certificationData.fileF = uploadedFiles[idx];
                }
              }
            }

            const res = await apiClient.put(
              "/certification/" + this.selectedCertType,
              certificationData,
            );
            this.$message.success(this.$t("success.certificationAjout"));
            res.data.key = res.data.id;
            this.data.push(res.data);
            this.cacheData = this.data.map((item) => ({ ...item }));
            this.handleCancel();
          } catch (e) {
            this.handleApiError(e, this.$t("error.impoAjoutCertification"));
          } finally {
            this.loadingClasse = false;
          }
        }
      });
    },
    showModal() {
      this.visibleModal = true;
    },
    handleCancel() {
      this.form.resetFields();
      this.formEdit.resetFields();
      this.visibleModal = false;
      this.visibleEditModal = false;
      this.uploadPercentage = { value: 0 };
      this.fileListM = [];
      this.fileListF = [];
      this.certifImageMale = null;
      this.certifImageFemale = null;
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(record) {
      this.formEdit = this.$form.createForm(this);
      this.visibleEditModal = true;
      this.fileListM = [];
      this.fileListF = [];
      this.certifImageMale = null;
      this.certifImageFemale = null;
      if (record.fileM) {
        const fileName = record.fileM.split("/").pop();
        // Find the position of the timestamp separator
        const separatorIndex = fileName.indexOf("--");
        const fileNameM =
          separatorIndex !== -1
            ? fileName.substring(separatorIndex + 2)
            : fileName;
        let filePath = this.settings.resourcesUrl.replace(
          "FILE_PATH",
          record.fileM
        );
        this.fileListM = [
          {
            uid: "-1",
            name: fileNameM,
            status: "done",
            url: filePath,
          },
        ];
      }
      if (record.fileF) {
        const fileName = record.fileF.split("/").pop();
        // Find the position of the timestamp separator
        const separatorIndex = fileName.indexOf("--");
        const fileNameF =
          separatorIndex !== -1
            ? fileName.substring(separatorIndex + 2)
            : fileName;
        let filePath = this.settings.resourcesUrl.replace(
          "FILE_PATH",
          record.fileF
        );
        this.fileListF = [
          {
            uid: "-2",
            name: fileNameF,
            status: "done",
            url: filePath,
          },
        ];
      }
      setTimeout(() => {
        this.formEdit.setFieldsValue({
          name: record.name,
          min: record.min,
          max: record.max,
          id: record.id,
          template: record.template,
        });
      }, 100);
    },
    printConfig(record) {
      this.keyIndex += 1;
      this.selectedCertif = record;
      this.visibleConfigPrintModal = true;
    },
    handelEdit(e) {
      e.preventDefault();
      this.formEdit.validateFieldsAndScroll(async (err, values) => {
        if (err) return;

        if (!err) this.loadingClasse = true;
        try {
          const id = values.id;
          delete values.id;

          const certificationData = {
            name: values.name,
            min: values.min,
            max: values.max,
          };

          // Get the current certification to check if files were removed
          const currentCert = this.data.find((cert) => cert.id == id);

          // Check if files were removed (fileList is empty but there was a file before)
          if (currentCert) {
            // Handle male certificate file removal
            if (this.fileListM.length === 0 && currentCert.fileM) {
              certificationData.fileM = null; // Set to null to indicate deletion
            }

            // Handle female certificate file removal
            if (this.fileListF.length === 0 && currentCert.fileF) {
              certificationData.fileF = null; // Set to null to indicate deletion
            }
          }

          const filesToUpload = [];
          if (this.certifImageMale) filesToUpload.push(this.certifImageMale);
          if (this.certifImageFemale)
            filesToUpload.push(this.certifImageFemale);

          if (filesToUpload.length > 0) {
            const uploadedFiles = await uploadFilesToS3(
              filesToUpload,
              "manager/certification",
              this.uploadPercentage
            );

            // Assign uploaded files to certification data (same order as filesToUpload: male then female)
            if (uploadedFiles.length > 0) {
              let idx = 0;
              if (this.certifImageMale) {
                certificationData.fileM = uploadedFiles[idx];
                idx++;
              }
              if (this.certifImageFemale) {
                certificationData.fileF = uploadedFiles[idx];
              }
            }
          }

          await apiClient.patch(
            "/certification/" + id + "/" + this.selectedCertType,
            certificationData,
          );

          await this.getCetification();
          this.$message.success(this.$t("success.certificationMSA"));
          this.visibleEditModal = false;
        } catch (error) {
          this.handleApiError(error, this.$t("error.modif"));
        } finally {
          this.loadingClasse = false;
          this.uploadPercentage = { value: 0 };
        }
      });
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
    supp(key) {
      apiClient
        .delete("/certification/" + key + "/" + this.selectedCertType)
        .then(() => {
          this.$message.success(this.$t("success.certificationSupp"));
          const dataSource = [...this.data];
          this.data = dataSource.filter((item) => item.key !== key);
        })
        .catch((e) => {
          this.handleApiError(e, this.$t("error.supp"));
        });
    },
    setDefaultCertifications() {
      this.data = this.defaultData.map((item) => ({ ...item }));
      this.cacheData = this.defaultData.map((item) => ({ ...item }));

      const certifParams = this.data.map((c) => ({
        id: c.id,
        name: c.name,
        min: c.min,
        max: c.max,
      }));

      const fieldName =
        this.selectedCertType === "MP"
          ? "certifParams"
          : this.selectedCertType === "college"
            ? "certifCollegeParams"
            : "certifSpecParams";

      apiClient
        .patch("/buildings/" + this.settings.activeBuildingId, {
          data: { [fieldName]: certifParams },
        })
        .then((res) => {
          this.$message.success(this.$t("certification.defaultDone"));
        })
        .catch((e) => {
          console.log(e);
          this.$message.error(this.$t("error.erreur"));
        });
    },

    handleClose() {
      this.visibleConfigPrintModal = false;
    },
    beforeUpload(file, gender) {
      const isPng = file.type === "image/png";
      if (!isPng) {
        this.$message.error(this.$t("error.fichiersPNG"));
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error(this.$t("error.image"));
      }
      if (isPng && isLt2M) {
        this.$message.success(
          this.$t("success.imageTelecharge", { name: file.name })
        );
        gender == "m"
          ? (this.certifImageMale = file)
          : (this.certifImageFemale = file);
      }
      return isPng && isLt2M;
    },
    addTofileList(gender, options) {
      if (gender == "m") this.fileListM = [this.certifImageMale];
      else this.fileListF = [this.certifImageFemale];
      options.onSuccess(this.$t("certification.fileUploadedSuccessfully"));
    },
    handleRemoveFile(file, gender) {
      if (gender === "m") {
        this.fileListM = [];
        this.certifImageMale = null;
      } else {
        this.fileListF = [];
        this.certifImageFemale = null;
      }
      return true;
    },
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.hidden {
  display: none;
}

.certificate-card {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
